// extracted by mini-css-extract-plugin
export default {"container":"ProfileCampaignCardGoalGeneric_container__EYGKm","currentAmount":"ProfileCampaignCardGoalGeneric_currentAmount__x2VCo"};